module.exports = "/_next/static/images/GeneralXS-8a7b49e191cce0d51603680396c655e8.svg";